import React, { useContext, useState } from "react";
import { store } from "store";
import InternalLink from "components/InternalLink";
import Loading from "components/Loading";
import { setResetPasswordUrlRedirect } from "core/Utils/SetResetPasswordUrl";

export default function LeftMenu() {
  const [isLoading, setIsLoading] = useState(false);
  const globalState = useContext(store);
  const { state } = globalState;
  const { user } = state;

  return (
    <>
      <Loading isLoading={isLoading} />
      <div className="mdn-LinkDetails">
        {/* <div className="mdn-LinkDetails-group mdn-u-marginBottom--xxs">
          <div className="mdn-Link mdn-Link--arrow">
            <a className="mdn-Link-anchor" href="/meuperfil/dados-cadastrais">
              Dados Cadastrais
            </a>
            <i className="mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--sm"></i>
          </div>
        </div> */}
        {/* <div className="mdn-LinkDetails-group mdn-u-marginBottom--xxs">
          <div className="mdn-Link mdn-Link--arrow">
            <a className="mdn-Link-anchor" href="/meuperfil/listar-numeros">
              Listar meus números
            </a>
            <i className="mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--sm"></i>
          </div>
        </div> */}
        <div className="mdn-LinkDetails-group mdn-u-marginBottom--xxs">
          <div className="mdn-Link mdn-Link--arrow">
            <InternalLink
              className="mdn-Link-anchor"
              link="/meuperfil/alterar-email"
              data-gtm-event-category="minha-claro:meu-perfil"
              data-gtm-event-action="clique:menu-opcoes"
              data-gtm-event-label="alterar-email"
              id="mdn-MainContent"
              tabIndex="13"
            >
              Alterar e-mail
            </InternalLink>
            <i className="mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--sm"></i>
          </div>
        </div>
        <div className="mdn-LinkDetails-group mdn-u-marginBottom--xxs">
          <div className="mdn-Link mdn-Link--arrow">
            <InternalLink
              className="mdn-Link-anchor"
              link="#"
              onClick={() => {
                setIsLoading(true);
                setResetPasswordUrlRedirect(user);
                setTimeout(() => setIsLoading(false), 1000);
              }}
              data-gtm-event-category="minha-claro:meu-perfil"
              data-gtm-event-action="clique:menu-opcoes"
              data-gtm-event-label="alterar-senha"
              tabIndex="14"
            >
              Alterar senha
            </InternalLink>
            <i className="mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--sm"></i>
          </div>
        </div>
        <div className="mdn-LinkDetails-group mdn-u-marginBottom--xxs">
          <div className="mdn-Link mdn-Link--arrow">
            <InternalLink
              className="mdn-Link-anchor"
              link="/meuperfil/meus-numeros"
              data-gtm-event-category="minha-claro:meu-perfil"
              data-gtm-event-action="clique:menu-opcoes"
              data-gtm-event-label="meus-numeros"
              tabIndex="15"
            >
              Meus Números
            </InternalLink>
            <i className="mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--sm"></i>
          </div>
        </div>
        <div className="mdn-LinkDetails-group mdn-u-marginBottom--xxs">
          <div className="mdn-Link mdn-Link--arrow">
            <InternalLink
              className="mdn-Link-anchor"
              link="/meuperfil/acesso-pelo-celular"
              data-gtm-event-category="minha-claro:meu-perfil"
              data-gtm-event-action="clique:menu-opcoes"
              data-gtm-event-label="acesso-pelo-celular"
              tabIndex="16"
            >
              Acesso pelo celular
            </InternalLink>
            <i className="mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--sm"></i>
          </div>
        </div>
        {/* <div className="mdn-LinkDetails-group mdn-u-marginBottom--xxs">
          <div className="mdn-Link mdn-Link--arrow">
            <a className="mdn-Link-anchor" href="/meuperfil/privacidade">
              Política de privacidade
            </a>
            <i className="mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--sm"></i>
          </div>
        </div> */}
      </div>
    </>
  );
}
